hasTimeArg